import React, { Component } from "react";
import PropTypes from "prop-types";
// import find from 'lodash.find';
import Dialog from "material-ui/Dialog";
import styled from "styled-components";
import RaisedButton from "material-ui/RaisedButton";
import SelectField from "material-ui/SelectField";
import { teal900 } from "material-ui/styles/colors";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import RemoveCircle from "material-ui/svg-icons/content/remove-circle";
import AddIcon from "material-ui/svg-icons/content/add-circle";
import { DivTitle } from "../../styled";
import TextInput from "../TextInput";
import { UploadImageMobile } from "../../../../../components";
import { Counter } from "../counter";
const customContentStyle = {
  width: "100%",
  maxWidth: "none",
};

const defaultItem = {
  href: {
    url: "",
    target: "",
    isCollection: false,
    collection: 0,
  },
  imageUrl: {
    url: "",
    urlMobile: "",
    desktop: {
      width: 0,
      height: 0,
    },
    mobile: {
      width: 0,
      height: 0,
    },
  },
  title: "",
  titleDiscount: "",
  discount: 0,
};

class DialogDealGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  onAddItem = () => {
    let list = this.props.list;
    list.push(defaultItem);
    this.props.onSetValue("list", list);
  };
  onDelete = (index) => {
    const newList = this.arrayRemove(this.props.list, index);
    this.props.onSetValue("list", newList);
    // this.setState({
    //   list: newList,
    // })
  };
  arrayRemove(arr, value) {
    arr.splice(value, 1);
    return arr;
  }
  updateItem = (key, value, index, item) => {
    let newList = this.props.list;
    let newItem = {
      ...item,
      [key]: value,
    };
    newList[index] = newItem;
    this.props.onSetValue("list", newList);
  };
  onChangeTarget = (event, index, value, indexParent, item) => {
    const newValue = value === "_blank" ? value : "";
    let newHref = item.href;
    newHref.target = newValue;
    let newItem = item;
    item["href"] = newHref;
    let newList = this.props.list;
    newList[indexParent] = newItem;

    this.props.onSetValue("list", newList);
  };
  onUpdateHrefUrl = (value, index, item) => {
    let newHref = item.href;
    newHref.url = value;
    let newItem = item;
    item["href"] = newHref;
    let newList = this.props.list;
    newList[index] = newItem;
    this.props.onSetValue("list", newList);
  };
  render() {
    const { list } = this.props;
    return (
      <div>
        <DivBox>
          <RaisedButton
            label="List Group"
            onClick={this.handleOpen}
            style={{ height: 40 }}
          />
        </DivBox>
        <Dialog
          title="List Group"
          modal={false}
          open={this.state.open}
          contentStyle={customContentStyle}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >
          <DivBox>
            <DivBoxRow style={{ justifyContent: "flex-end" }}>
              <IconButton
                onClick={() => this.onAddItem()}
                iconStyle={{ color: teal900 }}
              >
                <AddIcon />
              </IconButton>
              <div>Add Item</div>
            </DivBoxRow>
          </DivBox>
          <DivBox>
            {list &&
              list.length > 0 &&
              list.map((item, indexParent) => {
                const { target } = item.href;
                const valueTarget = target === "_blank" ? target : "same";
                return (
                  <DivBox key={indexParent}>
                    <DivBoxRow>
                      <DivBox>
                        <DivTitle>Upload Image</DivTitle>
                        <UploadImageMobile
                          type={"ImageView"}
                          imageUrl={item.imageUrl}
                          onUpdateUrl={(value) =>
                            this.updateItem(
                              "imageUrl",
                              value,
                              indexParent,
                              item
                            )
                          }
                          title="Image"
                        />
                      </DivBox>
                      <DivBox>
                        <div>
                          <DivTitle>Title</DivTitle>
                          <TextInput
                            value={item.title}
                            onChange={(value) =>
                              this.updateItem("title", value, indexParent, item)
                            }
                            title=""
                          />
                        </div>
                        <div>
                          <DivTitle>Title Discount</DivTitle>
                          <TextInput
                            value={item.titleDiscount}
                            onChange={(value) =>
                              this.updateItem(
                                "titleDiscount",
                                value,
                                indexParent,
                                item
                              )
                            }
                            title=""
                          />
                        </div>
                        <div>
                          <DivTitle> Discount</DivTitle>
                          <Counter
                            isDisabled={false}
                            onSetValue={(value) =>
                              this.updateItem(
                                "discount",
                                value,
                                indexParent,
                                item
                              )
                            }
                            value={item.discount}
                            interval={1}
                            maxValue={100}
                          />
                        </div>
                      </DivBox>
                      <DivBox>
                        <DivTitle>Action</DivTitle>
                        <SelectField
                          floatingLabelText="Target"
                          onChange={(event, index, value) =>
                            this.onChangeTarget(
                              event,
                              index,
                              value,
                              indexParent,
                              item
                            )
                          }
                          value={valueTarget}
                          autoWidth={true}
                          name="target href"
                        >
                          <MenuItem value={"same"} primaryText="Same Page" />
                          <MenuItem value={"_blank"} primaryText="New Page" />
                        </SelectField>
                        <TextInput
                          value={item.href.url}
                          onChange={(value) =>
                            this.onUpdateHrefUrl(value, indexParent, item)
                          }
                          name="HrefUrl"
                          title="Url"
                          fullWidth={true}
                        />
                      </DivBox>
                      <DivBox1>
                        <IconButton
                          onClick={() => this.onDelete(indexParent)}
                          iconStyle={{ color: teal900 }}
                        >
                          <RemoveCircle />
                        </IconButton>
                      </DivBox1>
                    </DivBoxRow>
                  </DivBox>
                );
              })}
          </DivBox>
        </Dialog>
      </div>
    );
  }
}

// const DivItemTemplate = styled.div`
//   padding:8px;
//   width: 150px;
//   &:hover{
//     cursor:pointer;
//     background-color: rgba(0,0,0,0.3);
//   }
// `;

// const DivImageContainer = styled.div`
//   display: inline-flex;
// `;

const DivBox = styled.div`
  padding: 8px 0px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const DivBox1 = DivBox.extend`
  padding: 8px;
  align-items: flex-end;
`;

const DivBoxRow = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

// const Image = styled.img`
//   opacity: 1;
//   display: block;
//   height: auto;
//   backface-visibility: hidden;
// `;

DialogDealGroup.propTypes = {
  onSetValue: PropTypes.func,
  list: PropTypes.array,
};

DialogDealGroup.defaultProps = {
  onItemSelected: () => {},
  list: [],
};

export default DialogDealGroup;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/dealList/DialogDealGroup.js